"use client";
import { cn } from "@/lib/utils";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Image from "next/image";
import React, { useState } from "react";
import { ALUMNI_AND_STUDENTS } from "@/lib/data/alumni-and-students"

const WordsFormOurLeaders = () => {
  const [index, setIndex] = useState<number>(0);
  return (
    <section
      className={cn(
        `mt-[25px]`,
        // `md:pl-[3.1875rem] md:pr-[3.125rem] `,
        `2xl:p-[0_5rem] xl:p-[0_5rem] md:p-[0_3.125rem]`
      )}
    >
      <header
        className={`overflow-hidden mt-0 mb-[2.0625rem] max-w-full clear-both table 
        m-[0_auto_1.3125rem] relative text-center w-full z-[1]
        `}
      >
        <h2
          // className="font-bold text-[1.75rem] md:text-[3.25rem] m-0 text-center leading-tight"
          className="font-bold text-[1.75rem] md:text-[2.25rem] m-0 text-center leading-tight"
        >
          Our Success Stories
        </h2>
      </header>
      <div className={cn(`w-full `)}>

        <div
          className={cn(
            `md:mb-[70px] md:max-w-[870px] `,
            `overflow-hidden m-[0_auto_45px]`
          )}
        >
          <div id="container" className={cn(``)}>
            {ALUMNI_AND_STUDENTS.map((item, idx) => {
              return (
                <div
                  key={item.name.toLocaleLowerCase()}
                  className={cn(
                    `xl:min-w-[870px] md:border-b md:border-b-[#939393] md:min-w-[668px] md:flex-col md:justify-between min-w-[280px] 
                    overflow-hidden pb-[40px]`,
                    {
                      "md:flex": idx === index,
                      "hidden": idx !== index,
                    }
                  )}
                >
                  <div
                    id="desc"
                    className={cn(
                      `md:flex-[0_0_auto] md:relative md:overflow-hidden`
                    )}
                  >
                    <svg
                      className={cn(
                        "md:block md:h-auto md:mb-[36px] md:p-[0_40px_0_0] md:w-auto"
                      )}
                      aria-hidden="true"
                      focusable="false"
                      width="90px"
                      height="69px"
                      viewBox="0 0 90 69"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          transform="translate(-262.000000, -371.000000)"
                          fill={
                            ALUMNI_AND_STUDENTS.at(index)?.category === "ALUMINI" ? "#df272a" : "#146ba9"
                          }
                        >
                          <g transform="translate(81.000000, 200.000000)">
                            <g transform="translate(0.000000, 171.000000)">
                              <path d="M221.197577,7.9054774 C216.942406,10.2175654 213.502108,12.2085002 210.876577,13.8783415 C208.251047,15.5481828 205.580288,17.7531966 202.864222,20.4934491 C200.329227,23.0624357 198.382743,25.7598313 197.02471,28.5857166 C195.666677,31.4116019 194.716068,35.0509451 194.172854,39.5038553 L200.69138,39.5038553 C206.304584,39.5038553 210.718125,40.8097373 213.932136,43.4215404 C217.146148,46.0333435 218.753129,49.8653577 218.753129,54.9176982 C218.753129,58.5142795 217.327216,61.87532 214.475347,65.0009204 C211.623477,68.1265208 207.707874,69.6892976 202.72842,69.6892976 C194.942364,69.6892976 189.374512,67.2702048 186.024697,62.4319466 C182.674882,57.5936884 181,51.2355418 181,43.357316 C181,37.7911783 182.267478,32.7175057 184.802473,28.1361462 C187.337468,23.5547866 190.41563,19.4658775 194.037052,15.8692962 C197.749009,12.187082 201.687245,9.06152846 205.85188,6.4925418 C210.016515,3.92355514 213.50208,1.82558084 216.308682,0.198555957 L221.197577,7.9054774 Z M271.444547,7.9054774 C267.189377,10.2175654 263.749078,12.2085002 261.123548,13.8783415 C258.498017,15.5481828 255.827259,17.7531966 253.111193,20.4934491 C250.485662,23.1480686 248.516544,25.8668721 247.203779,28.6499409 C245.891014,31.4330098 244.963038,35.0509451 244.419825,39.5038553 L250.938351,39.5038553 C256.551554,39.5038553 260.965095,40.8097373 264.179107,43.4215404 C267.393118,46.0333435 269.0001,49.8653577 269.0001,54.9176982 C269.0001,58.5142795 267.574187,61.87532 264.722317,65.0009204 C261.870448,68.1265208 257.954845,69.6892976 252.97539,69.6892976 C245.189334,69.6892976 239.621482,67.2702048 236.271668,62.4319466 C232.921853,57.5936884 231.246971,51.2355418 231.246971,43.357316 C231.246971,37.7911783 232.514449,32.7175057 235.049444,28.1361462 C237.584439,23.5547866 240.662601,19.4658775 244.284022,15.8692962 C247.995979,12.187082 251.934216,9.06152846 256.098851,6.4925418 C260.263485,3.92355514 263.749051,1.82558084 266.555653,0.198555957 L271.444547,7.9054774 Z"></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <hr
                      className={cn(
                        `md:relative md:top-[-65px] md:left-[130px] md:block 
                                            md:border-t md:border-t-black
                                            hidden
                                            `
                      )}
                    />
                    {/* <span className={cn(
                      `md:relative md:top-[-65px] md:left-180 md:text-lg md:font-black`
                    )}>400+</span> */}

                  </div>

                  <div
                    className={cn(
                      `md:self-center`
                    )}
                  >
                    <div
                      className={cn(
                        "mt-[21px] flex justify-center", // mobile: center image
                        `sm:float-none`,
                        "md:mt-0 md:justify-end", // tablet+
                        "md:float-right md:pl-[32px]", // float only on md+
                        "xl:mt-[-40px] xl:pl-[40px]"
                      )}
                    >
                      <Image
                        alt={item.name}
                        src={item.image}
                        width={230}
                        height={230}
                        sizes="
    (max-width: 767px) 115px,
    (max-width: 1209px) 164px,
    230px
  "
                        className={cn(
                          "rounded-full object-cover object-top block",
                          "w-[115px] h-[115px]", // mobile
                          "md:w-[164px] md:h-[164px]", // tablet
                          "xl:w-[230px] xl:h-[230px]", // desktop
                          {
                            "object-center": idx == 1
                          }
                        )}
                      />
                    </div>

                    <blockquote
                      className={cn(
                        "xl:text-[22px] xl:leading-[35px]",
                        "md:text-[18px] md:leading-[22px] md:block",
                        "text-[14px] italic leading-[28px] m-[0_0_21px]"
                      )}
                    >
                      {item.description &&
                        item.description.trim().length > 0 ? (
                        <>{item.description}</>
                      ) : (
                        <span className="not-italic text-gray-500">
                          No description provided.
                        </span>
                      )}
                    </blockquote>

                    <span
                      className={cn(
                        `md:text-base md:leading-[24px] md:block `,
                        `text-sm leading-[21px]`
                      )}
                    >
                      <span className={cn(`font-bold`)}>{item.name}</span>
                      <p
                        className={cn(
                          // `xl:mb-[.5rem]`,
                          `md:text-base md:leading-8`,
                          `text-[0.875rem] leading-[1.75rem] mt-0`
                        )}
                      >
                        <span className="italic">{item.category.charAt(0) + item.category.slice(1).toLowerCase()} - </span>
                        {item.batch}
                      </p>
                      <p
                        className={cn(
                          // `xl:mb-[.5rem]`,
                          `md:text-base md:leading-8`,
                          `text-[0.875rem] leading-[1.75rem] mt-0`
                        )}
                      >
                        {item.position}
                      </p>
                      {/* <p
                        className={cn(
                          `xl:mb-[1.5rem]`,
                          `md:mb-[1.9375rem] md:text-base md:leading-8`,
                          `text-[0.875rem] leading-[1.75rem] mb-[1.75rem] mt-0`
                        )}
                      >
                        {item.batch}
                      </p> */}

                      {/* <span className={cn(``)}>
                        <p
                          className={cn(
                            `xl:mb-[1.5rem]`,
                            `md:mb-[1.9375rem] md:text-base md:leading-8`,
                            `text-[0.875rem] leading-[1.75rem] mb-[1.75rem] mt-0`
                          )}
                        >
                          {item.category.charAt(0) + item.category.slice(1).toLowerCase()}
                        </p>
                      </span> */}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={cn(`md:border-t md:border-t-[#939393]`)}>
            <div
              className={cn(
                // `md:w-[170px]`,
                `md:w-[145px]`,
                `bg-white gap-x-[17px] flex text-base [justify-content:left] leading-[16px] relative top-[-10px]`
              )}
            >
              <button
                className={cn(
                  `bg-none cursor-pointer border-none`,
                  `before:content-[url("/svgs/longarrowleft-red.svg")]`
                )}
                onClick={() => {
                  setIndex((pre) => Math.max(pre - 1, 0));
                }}
                disabled={index === 0}
                aria-label="Previous leader"
              />
              <div className={cn(`m-[0_-14px_0_-10px]`)}>
                <span className={cn(`font-bold inline-block m-[0_2px]`)}>
                  {index + 1}
                </span>
                /
                <span className={cn(`inline-block m-[0_2px]`)}>
                  {ALUMNI_AND_STUDENTS.length}
                </span>
              </div>

              <button
                className={cn(
                  `bg-none cursor-pointer border-none`,
                  `before:content-[url("/svgs/longarrowright-red.svg")]`
                )}
                onClick={() => {
                  setIndex((pre) => Math.min(pre + 1, ALUMNI_AND_STUDENTS.length - 1));
                }}
                disabled={index === ALUMNI_AND_STUDENTS.length - 1}
                aria-label="Next leader"
              />

              {/* <div className={cn(`m-[0_-14px_0_-10px] bg-white`)}>
                <span className={cn(`font-bold inline-block m-[0_2px]`)}>500+</span>
              </div> */}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WordsFormOurLeaders;
